import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

export function useNavigateViaHash(
  ref,
  searchParamKey,
) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.hash === `#${searchParamKey}`) {
      ref?.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start",
      });
      void navigate(location.pathname, { preventScrollReset: true });
    }
  }, [location?.hash, location?.pathname]);
}